import React from 'react';
import {
    RiFileTextLine,
    RiTimeLine,
    RiAlarmWarningLine,
    RiFolder2Line,
} from 'react-icons/ri';
import { CatalogItem } from '../models';

interface CatalogStatsProps {
    list: CatalogItem[];
    onFilterPending?: () => void;
}

const CatalogStats: React.FC<CatalogStatsProps> = ({
    list,
    onFilterPending,
}) => {
    const totalDocs = list.length;
    const pendingDocs = list.filter((item) => item.status === 0).length;
    const publishedDocs = list.filter((item) => item.status === 1).length;
    const categoriesCount = new Set(list.map((item) => item.category)).size;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            {/* Total Documents Card */}
            <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md transition-all duration-300 flex items-center justify-between">
                <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                        Total Documents
                    </p>
                    <h3 className="text-3xl font-bold text-gray-800 dark:text-white">
                        {totalDocs}
                    </h3>
                    {/* <span className="text-xs font-medium text-emerald-600 dark:text-emerald-400 mt-2 inline-block">
                        +12 this month
                    </span> */}
                </div>
                <div className="w-14 h-14 rounded-2xl bg-[#4c8b6a]/10 dark:bg-[#4c8b6a]/20 flex items-center justify-center text-[#4c8b6a] text-2xl shadow-inner">
                    <RiFileTextLine />
                </div>
            </div>

            {/* Pending Approval Card */}
            <div
                onClick={onFilterPending}
                className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md transition-all duration-300 flex items-center justify-between cursor-pointer group"
            >
                <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                        Pending Approval
                    </p>
                    <h3 className="text-3xl font-bold text-amber-600 dark:text-amber-400">
                        {pendingDocs}
                    </h3>
                    <span className="text-xs font-medium text-amber-600/80 dark:text-amber-400/80 mt-2 inline-block group-hover:underline">
                        View pending items &rarr;
                    </span>
                </div>
                <div className="w-14 h-14 rounded-2xl bg-amber-50 dark:bg-amber-900/30 flex items-center justify-center text-amber-600 dark:text-amber-400 text-2xl shadow-inner">
                    <RiTimeLine />
                </div>
            </div>

            {/* Published / Active Card */}
            <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md transition-all duration-300 flex items-center justify-between">
                <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                        Published Documents
                    </p>
                    <h3 className="text-3xl font-bold text-emerald-600 dark:text-emerald-400">
                        {publishedDocs}
                    </h3>
                    <span className="text-xs font-medium text-gray-500 dark:text-gray-400 mt-2 inline-block">
                        Active & verified
                    </span>
                </div>
                <div className="w-14 h-14 rounded-2xl bg-emerald-50 dark:bg-emerald-900/30 flex items-center justify-center text-emerald-600 dark:text-emerald-400 text-2xl shadow-inner">
                    <RiAlarmWarningLine />
                </div>
            </div>

            {/* Categories Card */}
            <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm hover:shadow-md transition-all duration-300 flex items-center justify-between">
                <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                        Categories
                    </p>
                    <h3 className="text-3xl font-bold text-[#4c8b6a] dark:text-[#4c8b6a]">
                        {categoriesCount}
                    </h3>
                    <span className="text-xs font-medium text-[#4c8b6a]/80 dark:text-[#4c8b6a]/80 mt-2 inline-block">
                        Manage categories
                    </span>
                </div>
                <div className="w-14 h-14 rounded-2xl bg-[#4c8b6a]/10 dark:bg-[#4c8b6a]/20 flex items-center justify-center text-[#4c8b6a] text-2xl shadow-inner">
                    <RiFolder2Line />
                </div>
            </div>
        </div>
    );
};

export default CatalogStats;
